import { render, staticRenderFns } from "./HelpBubble.vue?vue&type=template&id=4138bb4e&scoped=true&"
import script from "./HelpBubble.vue?vue&type=script&lang=js&"
export * from "./HelpBubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4138bb4e",
  null
  
)

export default component.exports